import * as Types from '@saas/interfaces/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FetchNotificationInAppQueryVariables = Types.Exact<{
  userId: Types.Scalars['ID']['input'];
  source: Types.Scalars['String']['input'];
}>;


export type FetchNotificationInAppQuery = (
  { __typename?: 'Query' }
  & { notificationInApps: (
    { __typename?: 'NotificationInAppConnection' }
    & { edges?: Types.Maybe<Array<Types.Maybe<(
      { __typename?: 'NotificationInAppEdge' }
      & { node?: Types.Maybe<(
        { __typename?: 'NotificationInApp' }
        & Pick<Types.NotificationInApp, 'id' | 'objectId' | 'content' | 'isRead' | 'source' | 'createdAt' | 'updatedAt'>
      )> }
    )>>> }
  ) }
);


export const FetchNotificationInAppDocument = gql`
    query fetchNotificationInApp($userId: ID!, $source: String!) {
  notificationInApps(
    where: {user: {have: {objectId: {equalTo: $userId}}}, isRead: {equalTo: false}, source: {equalTo: $source}}
  ) {
    edges {
      node {
        id
        objectId
        content
        isRead
        source
        createdAt
        updatedAt
      }
    }
  }
}
    `;

/**
 * __useFetchNotificationInAppQuery__
 *
 * To run a query within a React component, call `useFetchNotificationInAppQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchNotificationInAppQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchNotificationInAppQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useFetchNotificationInAppQuery(baseOptions: Apollo.QueryHookOptions<FetchNotificationInAppQuery, FetchNotificationInAppQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchNotificationInAppQuery, FetchNotificationInAppQueryVariables>(FetchNotificationInAppDocument, options);
      }
export function useFetchNotificationInAppLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchNotificationInAppQuery, FetchNotificationInAppQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchNotificationInAppQuery, FetchNotificationInAppQueryVariables>(FetchNotificationInAppDocument, options);
        }
export type FetchNotificationInAppQueryHookResult = ReturnType<typeof useFetchNotificationInAppQuery>;
export type FetchNotificationInAppLazyQueryHookResult = ReturnType<typeof useFetchNotificationInAppLazyQuery>;
export type FetchNotificationInAppQueryResult = Apollo.QueryResult<FetchNotificationInAppQuery, FetchNotificationInAppQueryVariables>;